import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReleaseBannerComponent } from './release-banner.component';

@NgModule({
  declarations: [
    ReleaseBannerComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    ReleaseBannerComponent
  ]
})
export class ReleaseBannerModule { }
